import axios from "axios";
import { logout } from "../lib/auth";
import { accountTableColumn } from "../config/account";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// MGR商材権限一覧取得
export async function getOutsideEntryFormGroups(id: string) {
  try {
    const path = "outsideEntryFormGroups";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      groupDatas: response.data.group_data,
    };
  } catch (error) {
    return { sudDatas: [], groupDatas: [] };
    // logout();
  }
}

// MGR商材権限登録
export async function postOutsideEntryFormGroups(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntryFormGroups";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
